module.exports = __webpack_public_path__ + "img/target_education.db0bd232.svg";